<div class="flex flex-col h-full">
    <div class="border-b border-gray-200">
        <div class="flex gap-1">
            @for(tab of availableTabs(); track tab.value) {
            <button class="px-4 py-2 font-medium transition-colors"
                [class.text-blue-600]="activeTabIndex() === tab.value"
                [class.border-b-2]="activeTabIndex() === tab.value"
                [class.border-blue-600]="activeTabIndex() === tab.value"
                [class.text-gray-600]="activeTabIndex() !== tab.value" (click)="activeTabIndex.set(tab.value)">
                {{tab.label}}
            </button>
            }
        </div>
    </div>
    <div class="flex-1 overflow-auto py-3">
        @switch(getTabType(activeTabIndex())) {
        @case('source') {
        <app-source-tab [sources]="sources"></app-source-tab>
        }
        @case('comments') {
        <app-comments-tab [itemId]="question" [contractId]="contract" [commentsType]="COMMENTS_TYPE.QUESTION"
            [userRole]="userRole()"></app-comments-tab>
        }
        @case('history') {
        <app-history-tab [auditModule]="AUDIT_MODULE.DOCUMENT_FORM" [filter]="{
                    contractId: contract
                }"></app-history-tab>
        }
        }
    </div>
</div>
